export default "__VITE_ASSET__242b653f__"